// Sabhi .header__inline-menu aur .header-right-menu elements ko select kar rahe hain
let menus = document.querySelectorAll(".header__inline-menu, .header-right-menu");

menus.forEach(menu => {
  // Har menu ke andar sabhi details elements ko select kar rahe hain
  let items = menu.querySelectorAll("details");
  console.log(items);
  items.forEach(item => {
    let timeout;
    
    // mouseover event ke liye listener add kar rahe hain
    item.addEventListener("mouseover", () => {
      clearTimeout(timeout);
      item.setAttribute("open", true);
    });
    
    // mouseleave event ke liye listener add kar rahe hain
    item.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 200);  // 200ms ka delay add kar rahe hain
    });

    // submenu par mouseleave event ke liye listener add kar rahe hain
    let submenu = item.querySelector("ul");
    if (submenu) {
      submenu.addEventListener("mouseleave", () => {
        timeout = setTimeout(() => {
          item.removeAttribute("open");
        }, 200);  // 200ms ka delay add kar rahe hain
      });

      submenu.addEventListener("mouseover", () => {
        clearTimeout(timeout);
      });
    }
  });
});



/*****Header Menu Drawer Close Icon *****/

document.addEventListener('DOMContentLoaded', function() {
  const closeButton = document.getElementById('menu-drawer-close');
  const body = document.body; // Or the specific element that gets the class

  closeButton.addEventListener('click', function() {
    // Assuming `gradient overflow-hidden-tablet` is added to body
    body.classList.remove('overflow-hidden-tablet');
    // Additional logic for closing the menu drawer, if needed
  });
});



$(".cta-footer").on('click', function() {
  $(".cta-footer-main").addClass('model-open');
  $("body").addClass('sign-up-form'); // Add class to body
}); 

$(".close-btn, .bg-overlay").click(function(){
  $(".cta-footer-main").removeClass('model-open');
  $("body").removeClass('sign-up-form'); // Remove class from body
});

